import { Navigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

interface IProtectedRouteProps {
    element: React.ReactNode;
}

const ProtectedRoute = ({ element }: IProtectedRouteProps) => {
    const token = Cookies.get('token');
    const location = useLocation();


    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }



    return <>{element}</>;
};

export default ProtectedRoute;
